import { IWithContextProps, withContext } from '@tock/coretypes';
import { IconChevronSmallLeft } from '@tock/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { PureComponent } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Typography } from 'omakase';
import { css } from '@emotion/react';
import Anchor from 'components/Anchor';

class AccountBackNav extends PureComponent<RouteComponentProps & IWithContextProps> {
  goBack = () => {
    this.props.history.push('/profile/reservations');
  };

  render() {
    return (
      <nav aria-label="account-nav-back" className="Account-nav is-back">
        <Anchor onClick={this.goBack}>
          <div className="Account-navItem">
            <div
              css={
                this.props.context.isFeatureEnabled('SAKE_ICON_SET') && [
                  css`
                    display: flex;
                  `,
                ]
              }
              className="Account-navArrowLeft"
            >
              <IconMigrationUtil
                legacyIcon={<i className="tock-icon icon_arrow-left" />}
                newIcon={<IconChevronSmallLeft />}
              />
            </div>
            <Typography color="inherit" component="span" variant="body02Strong">
              All reservations
            </Typography>
          </div>
        </Anchor>
      </nav>
    );
  }
}

export default withRouter(withContext(AccountBackNav));
